import { yup } from '@medely/ui-kit';

export const positionsSchema = (step: number, LAST_STEP: number) =>
  yup.object({
    professional_positions: yup.object({
      positions: yup
        .array()
        .of(
          yup.object({
            id: yup.number(),
            years_of_experience: yup.number().when([], (_, sch) => {
              return step === LAST_STEP ? sch.required('Required') : sch.nullable();
            }),
            specialty_ids: yup.array().of(yup.number()),
          }),
        )
        .min(1, ' ')
        .required(),
    }),
  });
